let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i5Fj1")).then(() => parcelRequire('a1qSg'));